import React from 'react';
import { Route, Redirect, withRouter } from 'react-router';
import { connect } from 'react-redux';
import Proptypes from 'prop-types';

export const DefaultRoute = ({ authStatus, ...rest }) => (
  <Route
    {...rest}
    render={() =>
      typeof authStatus === 'undefined' || authStatus === false ? (
        <Redirect to="/login" />
      ) : (
        <Redirect to="/" />
      )
    }
  />
);

DefaultRoute.propTypes = {
  component: Proptypes.func.isRequired,
  authStatus: Proptypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isAuthenticated: state.appReducer.isAuthenticated,
});

export default withRouter(connect(mapStateToProps)(DefaultRoute));
